import apiClient from '../../../common/functions/api_axios_instance.function';

/**
 * Fetches a document as a blob and creates a blob URL
 * @param {string} invoiceId - The invoice ID
 * @param {string|number} documentId - The document ID
 * @returns {Promise<string>} - Returns a blob URL that can be used in iframe/src
 */
export const getDocumentBlob = async (invoiceId, documentId) => {
  try {
    // Fetch document as blob
    const response = await apiClient.get(`/vendor/invoice/${invoiceId}/documents/${documentId}`, {
      responseType: 'blob', // Important: fetch as blob
    });

    // Create blob URL from the response
    const blob = new Blob([response.data], { type: response.data.type || 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);

    return blobUrl;
  } catch (error) {
    console.error('Error fetching document blob:', error);
    throw error;
  }
};

/**
 * Revokes a blob URL to free up memory
 * @param {string} blobUrl - The blob URL to revoke
 */
export const revokeBlobUrl = (blobUrl) => {
  if (blobUrl && blobUrl.startsWith('blob:')) {
    URL.revokeObjectURL(blobUrl);
  }
};
